import { render, staticRenderFns } from "./page-breadcrumb.vue?vue&type=template&id=1cc47e56&scoped=true"
import script from "./page-breadcrumb.vue?vue&type=script&lang=js"
export * from "./page-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./page-breadcrumb.vue?vue&type=style&index=0&id=1cc47e56&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/bread.less?vue&type=style&index=1&id=1cc47e56&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc47e56",
  null
  
)

export default component.exports